import { createFileRoute, redirect } from "@tanstack/react-router";

import RegisterPage from "~/pages/auth/RegisterPage.tsx";
import { HOME_PATH } from "~/routes/-route-constants/appRoutes.ts";

export const Route = createFileRoute("/register")({
    validateSearch: (search: Record<string, unknown>): { token?: string } => {
        return {
            token: search.token as string,
        };
    },
    beforeLoad: ({ context }) => {
        if (context.auth.user) {
            throw redirect({ to: HOME_PATH });
        }
    },
    component: RegisterPage,
});
